import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './ConfirmDeleteFlexpassModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ConfirmDeleteFlexpassModal extends Component {

	render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isDeleteFlexpassOpen} toggle={this.props.toggleConfirmDeleteFlexpass}>
		          	<ModalHeader toggle={this.props.toggleConfirmDeleteFlexpass}>{strings.title}</ModalHeader>
		          	<ModalBody>
					  	{strings.description}
		          	</ModalBody>
		          	<ModalFooter className="justify-content-center">
		            	<button 
		            		className="showtix-button showtix-background__grey-1"
                            onClick={this.props.toggleConfirmDeleteFlexpass}
		            		>{strings.cancel}</button>
                        <button 
		            		className="showtix-button showtix-background__primary-3"
                            onClick={this.props.confirmConfirmDeleteFlexpass}
		            		>{strings.stopSales}</button>    
		          	</ModalFooter>
		        </Modal>
			</div>
	  	);
	}
}

ConfirmDeleteFlexpassModal.propTypes = {
    isDeleteFlexpassOpen: PropTypes.bool,
    toggleConfirmDeleteFlexpass: PropTypes.func,
    confirmConfirmDeleteFlexpass: PropTypes.func,
}

export default ConfirmDeleteFlexpassModal;


// WEBPACK FOOTER //
// ./src/components/Common/ConfirmDeleteFlexpassModal/ConfirmDeleteFlexpassModal.js